import { CompositeOffer } from '@plus-int/acq-toolkit';
import { Offer } from '@funtech-int/yango-shared';

export const getOfferTitle = (offer: Offer | null | undefined): string =>
    [offer?.offerTexts?.buttonText, offer?.offerTexts?.buttonTextWithDetails]
        .filter(Boolean)
        .join(', ');

export const getAcqOfferPlanType = (catalogCompositeOffer: CompositeOffer | null | undefined) => {
    const tariff = catalogCompositeOffer?.tariffOffer;
    const option = catalogCompositeOffer?.optionOffers?.[0];
    const offer = option?.name ? option : tariff;

    const isTrial = Boolean(
        ['TRIAL_PLAN', 'TRIAL_UNTIL_PLAN'].includes(offer?.plans?.[0]?.typename ?? '')
    );
    const isIntro = Boolean(
        ['INTRO_PLAN', 'INTRO_UNTIL_PLAN'].includes(offer?.plans?.[0]?.typename ?? '')
    );
    const isFullPrice = !isTrial && !isIntro;

    return {
        isTrial,
        isIntro,
        isFullPrice,
    };
};
